import { styled } from '@mui/material/styles';
import { Button as BaseButton } from 'components/buttons';
import backgroundImage from './images/header.jpg';

export const Details = styled('div')(({ theme }) => ({
  color: theme.color.primary.contrast,
  fontSize: theme.fontSize.large,
  padding: theme.spacing(5, 0)
}));

export const Headline = styled('h3')(({ theme }) => ({
  color: theme.color.primary.contrast,
  fontSize: theme.fontSize.title,
  fontWeight: theme.fontWeight.light,
  margin: 0,
  marginTop: '40px'
}));

export const LinkButton = styled(BaseButton)(() => ({
  textDecoration: 'none'
}));

export const Phrase = styled('p')(() => ({
  margin: 0
}));

export const Slide = styled('div')(({ theme, dataImg }) => ({
  alignItems: 'flex-end',
  backgroundSize: 'cover',
  display: 'flex',
  minHeight: '320px',
  padding: theme.spacing(5, 0),
  textAlign: 'left',
  background: `linear-gradient( to right, ${theme.color.primary.main}, rgba(0, 0, 0, 0.5) ), top right / cover no-repeat url(${dataImg})`,
  color: theme.color.primary.contrast,
  '@media (min-width: 1024px)': {
    background: `top right / cover no-repeat url(${dataImg})`
  }
}));

export const Subject = styled('h4')(({ theme }) => ({
  color: theme.color.primary.contrast,
  fontSize: theme.fontSize.title,
  fontWeight: theme.fontWeight.bold,
  margin: 0
}));

export const ButtonsContainer = styled('div')(({ theme }) => ({
  margin: theme.spacing(-1),
  [`& ${LinkButton}`]: {
    margin: theme.spacing(1)
  }
}));

export const NewsSection = styled('div')(() => ({
  backgroundSize: 'cover',
  display: 'flex',
  minHeight: '320px',
  textAlign: 'left',
  background: `center url(${backgroundImage})`
}));
